import Swal from 'sweetalert2';

export const showError = (titleOrMessage, maybeText) => {
  let title = 'Error';
  let text = titleOrMessage;
  if (maybeText !== undefined) {
    title = titleOrMessage;
    text = maybeText;
  }
  Swal.fire({ icon: 'error', title, text });
};

export const showSuccess = (message) => {
  Swal.fire({ icon: 'success', title: 'Éxito', text: message });
};
export const showWarning = (titleOrMessage, maybeText) => {
  let title = 'Advertencia';
  let text = titleOrMessage;
  if (maybeText !== undefined) {
    title = titleOrMessage;
    text = maybeText;
  }
  Swal.fire({ icon: 'warning', title, text });
};
export function showLoading(title = 'Procesando...', text = 'Esto puede tardar unos segundos') {
  Swal.fire({
    title,
    text,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });
}

export function closeLoading() {
  Swal.close();
}

